const config = {"region":"eu-central-1","apiUrl":"https://o3g6o6wsh6.execute-api.eu-central-1.amazonaws.com/","userPoolId":"eu-central-1_FU2po2z6H","userPoolWebClientId":"6rhbi4j5m6vj9dpj6ltl24m6qm","authenticationFlowType":"USER_PASSWORD_AUTH"};

export default config;

